@if (isValidLoader()) {
  <div class="ui-core-ellipsis text-center position-relative">
    <div class="ui-core-ellipsis-logo">
      <img crossorigin [src]="themeLoader()?.logo" alt="logo" />
    </div>
    <div class="ui-core-ellipsis-loader d-flex justify-content-center gap-2 align-items-center mt-4">
      <div class="ui-core-ellipsis-loader-dots d-flex gap-2">
        <span class="dot" [style.background-color]="themeLoader()?.primary"></span>
        <span class="dot" [style.background-color]="themeLoader()?.secondary"></span>
        <span class="dot" [style.background-color]="themeLoader()?.primary"></span>
      </div>
    </div>
  </div>
}
